import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonService, AlertService, AdminService } from '../../../_services/';

@Component({
  selector: 'app-clear-database',
  templateUrl: './clear-database.component.html',
  styleUrls: ['./clear-database.component.scss']
})
export class ClearDatabaseComponent implements OnInit {
  loginForm:FormGroup;
  submitted:Boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin:AdminService
  ) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['dev@gregorysmith.ws', [Validators.required, Validators.email, Validators.maxLength(200)]],
      password: ['dev@gregorysmith.ws', [Validators.required, Validators.minLength (6)]]
    })

  }


  get fval() {
    return this.loginForm.controls;
  }

  onFormSubmit():void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    } 
    let form = this.loginForm.value;
    form.uid = localStorage.getItem('uid');
    this._common.showLoader(true);
    this._admin.clearDatabase(form).subscribe(res => {
      this._common.showLoader(false);
      this._alert.success(res.message);
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    }) 
  }

}
